'use strict';

module.exports = {
  opening: 0,
  opened: 1,
  closing: 2,
  closed: 3
};


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/layout/src/nav/NavDrawerStates.js